/* unplugin-vue-components disabled */import script from "./grade.vue?vue&type=script&lang=ts&setup=true"
export * from "./grade.vue?vue&type=script&lang=ts&setup=true"

export default script